import api from '@/services/Api';

class EstimateTransporterCostService {
  async getEstimateTransporterCost(repairFileId) {
    const response =
      await api.get('/distributor/estimate-transporter-cost/' + repairFileId)
    return response.data
  }
}

export default new EstimateTransporterCostService()
